import posthog from "posthog-js";

// Lives here because eslint funnels posthog-js imports through src/analytics.
export function optInPosthogCapturing(): void {
  posthog.opt_in_capturing();
}
